import React from 'react'

import { Toggle, Expand } from './Expand'
import CountUpWrapper from 'src/components/CountUpWrapper'

const useBreakdown = ({ partnerItems, getTotals, toggleExpanded, expanded }) => {
  if (partnerItems.length <= 1)
    return { toggle: null, expand: null }

  const toggle =
    <Toggle
      id="breakdown"
      label="See breakdown"
      toggleExpanded={toggleExpanded}
    />

  const expand =
    <Expand id="breakdown" expanded={expanded}>
      <ul className="list-unstyled mb-0 py-2">
        {partnerItems.map(partnerItem =>
          <li key={partnerItem.external_id} role="alert">
            <CountUpWrapper
              amount={getTotals(partnerItem).raised}
              prefix="$"
              decimalPlaces="2"
            />
            {' raised for '}{partnerItem.beneficiary_name}
          </li>
        )}
      </ul>
    </Expand>

  return { toggle, expand }
}

export default useBreakdown
